import {Ventrata} from 'types'

export const getBookingByUuid = (order: Ventrata.Order, bookingUuid: string) => {
  const booking = order.bookings.find((booking) => booking.uuid === bookingUuid)

  if (!booking) {
    throw new Error(`Can't find booking by uuid '${bookingUuid}'`)
  }

  return booking
}
